// Generic imports
import styled from "styled-components"

// Static imports

export const ClassStyles = styled.div`
  background: #ffffff;

  .top-class,
  .desc-class {
    max-width: 1140px;
    padding-left: 22px;
    padding-right: 22px;
    margin: auto;
  }

  .top-class {
    display: flex;
  }

  .top-class-wrapper {
    background: #ffffff;
    padding-top: 50px;
    padding-bottom: 30px;
  }

  .class-logo {
    width: 260px;
    margin-right: 40px;
    border: 1px solid #cacccf;
    box-sizing: border-box;
    border-radius: 4px;
    height: 260px;
    background-repeat: no-repeat;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }

  .short-desc {
    padding-top: 10px;
    width: calc(100% - 260px);
  }

  .short-desc h1 img {
    padding-left: 15px;
  }

  .top-class h5 {
    padding-bottom: 10px;
  }

  .top-class .tags {
    padding-top: 10px;
    line-height: 3;
  }

  .tags .tag-wrapper {
    display: inline-block;
  }

  .bagikan-wrapper {
    padding-top: 15px;
  }

  .tags a {
    background: #ffffff;
    border: 1px solid #cacccf;
    box-sizing: border-box;
    border-radius: 200px;
    padding: 8px 16px;
    margin-right: 8px;
    color: black;
  }

  .tags a:hover {
    text-decoration: none;
  }

  .desc-class {
    display: flex;
    padding-top: 40px;
    padding-bottom: 80px;
  }

  .desc-class-left {
    width: calc(100% - 300px);
    padding-right: calc(5% + 10px);
  }

  .desc-class-right {
    width: 300px;
  }

  .small-nav {
    display: flex;
    border-bottom: 1px solid #cacccf;
    margin-bottom: 20px;
    font-size: 1.1em;
  }

  .small-nav div {
    margin-right: 35px;
    padding-top: 10px;
    padding-bottom: 8px;
    padding-left: 6px;
    padding-right: 6px;
    margin-bottom: -2.5px;
    cursor: pointer;
  }

  .countdown {
    font-weight: bold;
    padding-top: 25px;
  }

  .tutup-pendaftaran {
    font-weight: bold;
    padding-top: 10px;
  }

  .tempat-tgl {
    font-weight: bold;
    padding-top: 8px;
  }

  .tempat-tgl img {
    width: 22px;
    margin-right: 10px;
    position: relative;
    bottom: 2px;
  }

  .narahubung {
    font-weight: bold;
    padding-bottom: 16px;
  }

  .all-desc-here {
    white-space: pre-wrap;
  }

  .section-judul {
    padding-top: 10px;
  }

  .tentang-kelas img {
    padding-top: 15px;
    padding-bottom: 20px;
  }

  .pengajar-baris {
    display: flex;
    padding-top: 5px;
    padding-bottom: 30px;
    align-items: center;
  }

  .pengajar-left {
    width: 23.5%;
    height: 0;
    padding-bottom: 23.5%;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }

  .pengajar-right {
    padding-left: 40px;
    width: 76.5%;
  }

  .pengajar-right h4 {
    margin-bottom: 8px;
  }

  .pengajar-right h5 {
    font-size: 1.1em;
    margin-bottom: 12px;
  }

  .closed {
    padding-top: 1rem;
  }

  .closed button {
    background: rgba(235, 87, 87, 0.25);
    border: 0;
    border-radius: 4px;
    color: #eb5757;
    width: 240px;
    height: 3rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .closed button:hover {
    cursor: default;
    opacity: 1;
  }

  .warning-img-wrapper {
    width: 25px;
    height: auto;
    margin-right: 0.5rem;
  }

  .share-button {
    line-height: 1.5;
    background-color: white;
    color: #51b848;
  }

  .share-button span {
    height: 100%;
  }

  .share-img-wrapper {
    width: 15px;
    height: auto;
    position: relative;
    top: 3px;
    margin-right: 10px;
  }

  @media (max-width: 1000px) {
    .top-class {
      flex-wrap: wrap;
    }

    .class-logo {
      margin: auto;
      border-radius: 50%;
      margin-bottom: 5px;
    }

    .short-desc {
      width: 100%;
      text-align: center;
    }

    .bagikan-wrapper {
      button {
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  @media (max-width: 767px) {
    h1 {
      font-size: 2em;
    }

    .small-nav {
      justify-content: space-evenly;
      margin-left: -22px;
      margin-right: -22px;
    }

    .small-nav div {
      margin-right: 0;
    }

    .desc-class {
      flex-wrap: wrap;
    }

    .desc-class-left {
      width: 100%;
      padding-right: 0;
    }

    .desc-class-right {
      width: 100%;
    }

    .desc-class-right button {
      width: 100%;
      margin-top: 8px;
    }
  }

  @media (max-width: 500px) {
    .class-logo {
      width: 60%;
      height: 0;
      padding-bottom: 60%;
    }
  }
`
